module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('div', {
    attrs: {
      "id": "neirong"
    }
  }, [_c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "150px",
      "font-size": "23px",
      "color": "red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', {
    staticStyle: {
      "border": "0px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("报价单号："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("客户名称 :"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("报价方："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系人："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("报价人："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("电话："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("电话："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("邮箱："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px",
      "line-height": "50px"
    }
  }, [_vm._v("  \r\n            尊敬的  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.providePartsMaterial),
      expression: "data.providePartsMaterial"
    }],
    staticStyle: {
      "border": "solid",
      "border-left": "0px",
      "border-top": "0px",
      "border-right": "0px",
      "margin-left": "0px",
      "height": "30px",
      "outline": "medium",
      "font-size": "21px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "maxlength": "3800",
      "size": "15"
    },
    domProps: {
      "value": (_vm.data.providePartsMaterial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "providePartsMaterial", $event.target.value)
      }
    }
  }), _vm._v("  先生/女士：  "), _c('br'), _vm._v("\r\n                 您好！感谢您对我实验室业务的垂询，以下是我们根据您的询价信息提供的报价。\r\n       ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "line-height": "28px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.list1), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('th', [_vm._v(_vm._s(i + 1) + " ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("啊请稍等 ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("型号规格（样品描述）")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("数量 ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("检测项目 ,x.fgnb,mxcnv,,ssssssssssss111111111111111111111111111111111111111111111111")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("检测项目 ,x.fgnb,mxcnv,,ssssssssssss11111111111111111111111111111111111111111111111111")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v(" 11 ")])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }), _vm._v(" "), _c('th', [_vm._v("合计 ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _vm._m(4)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "50px",
      "border-bottom": "2px solid black",
      "width": "150px"
    },
    on: {
      "click": function($event) {
        _vm.imgDialog = true;
      }
    }
  }, [(_vm.data.signaturelink) ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "45px"
    },
    attrs: {
      "src": _vm.data.signaturelink
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _c('br'), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter"
  }, [_c('el-dialog', {
    attrs: {
      "title": "授权人签名",
      "visible": _vm.imgDialog,
      "width": "900px",
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.imgDialog = $event
      }
    }
  }, [_c('esign', {
    attrs: {
      "token": _vm.data.timeStamp + _vm.data.conId,
      "imgDialog": _vm.imgDialog
    },
    on: {
      "callback": _vm.receiveSignature
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "ont-size": "14px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1000px",
      "min-width": "1000px",
      "margin": "0 auto",
      "font-size": "20px",
      "margin-top": "10px",
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("报 价 单")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("工业和信息化部电子第五研究所  （中  国  赛  宝  实  验  室）  装备与整机研究部")]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sava('暂存');
      }
    }
  }, [_vm._v(" 暂存 ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "-150px",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit('提交');
      }
    }
  }, [_vm._v(" 提交 ")])], 1), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("序号 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("样品名称 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("型号规格（样品描述）")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("数量 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v("检测项目 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("检测依据/测试条件 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("费用（RMB） ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "rowspan": "4"
    }
  }, [_c('p', [_vm._v("收款账户：")]), _vm._v(" "), _c('p', [_vm._v("  单位名称：工业和信息化部电子第五研究所")]), _vm._v(" "), _c('p', [_vm._v("  开户银行：中信银行广州分行")]), _vm._v(" "), _c('p', [_vm._v("  银行帐号：7443020183100002212")]), _vm._v(" "), _c('p', [_vm._v("  汇款时请备注“装备与整机研究部”和“报价单号”")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\r\n                  付款方式：\r\n                 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "rowspan": "4"
    }
  }, [_c('p', [_vm._v("备注：")]), _vm._v(" "), _c('p', [_vm._v("  1、此报价依据贵单位提供的询价信息给出，如实际委托时的要求与此报价单询价信息不符，将导致报价变化；")]), _vm._v(" "), _c('p', [_vm._v("  2、此报价不含重测费，如重测，按具体项目收费；")]), _vm._v(" "), _c('p', [_vm._v("  3、如项目进行过程中，委托方要求终止测试，则已测试的项目要收费；")]), _vm._v(" "), _c('p', [_vm._v("  4、此报价单有效期15天，超过15天未签字确认，则此报价失效；")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("  如同意以上报价，请签字盖章后回传。此报价单将做为服务和收费依据。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "height": "50px"
    }
  }, [_c('br'), _vm._v("客户签字:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "height": "50px",
      "border-bottom": "2px solid black",
      "width": "130px"
    }
  }, [_c('br'), _vm._v("11"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "height": "50px"
    }
  }, [_c('br'), _vm._v("报价人:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "height": "50px"
    }
  }, [_c('br'), _vm._v("工业和信息化部电子第五研究所装备与整机研究部")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "9%",
      "margin-top": "-62px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": require("../../assets/favicon.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "6px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  CEPREI-ZB-HT01-202102")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60641e8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/consignation/quoteSignature.vue
// module id = 1207
// module chunks = 10